import { render, staticRenderFns } from "./RecordsApp.vue?vue&type=template&id=33d75f5c&scoped=true"
import script from "./RecordsApp.vue?vue&type=script&lang=js"
export * from "./RecordsApp.vue?vue&type=script&lang=js"
import style0 from "./RecordsApp.vue?vue&type=style&index=0&id=33d75f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d75f5c",
  null
  
)

export default component.exports